import moment from 'moment';

import type { NUtils } from '@app/types/Utils';

export const compareTwoDates: NUtils.CompareTwoDates = (date1, date2) => {
  const momentDate1 = moment(date1);
  const momentDate2 = moment(date2);

  return momentDate1.isAfter(momentDate2);
};
